// import ModalForm from "./Form";
import EventRegistrationDetailTableForm from "./EventRegistrationDetailTableForm";
import {
	EVENT_REGISTRATION_DETAIL,
	DATATABLE_EXPORT,
} from "../../../../Config/ApiUrl";
import * as actions from "../../../../Config/ApiUrl";

export const EventRegistrationDetailTableSchema = {
	components: { EventRegistrationDetailTableForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			Endpoint: EVENT_REGISTRATION_DETAIL,
			tableId: "event-registration-detail-table",
			formId: "event-registration-detail-table-form",
			rowData: {},
			tableColumns: [
				{
					title: "Date",
					type: "text",
					key: "date",
				},
				{
					title: "Start Time",
					type: "text",
					key: "time_start_formatted",
				},
				{
					title: "End Time",
					type: "text",
					key: "time_end_formatted",
				},
				{
					title: "Location",
					type: "text",
					key: "location",
				},
			],
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "EventRegistrationDetailTable",
				url: EVENT_REGISTRATION_DETAIL,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						// component: "app-add-modal",
						component: "event-registration-detail-table-form",
						modalId: "event-registration-detail-table-form",
					},
					{
						title: this.$t("delete"),
						icon: "trash",
						type: "none",
						component: "app-confirmation-modal",
						modalId: "demo-delete",
					},
				],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 3,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {},
};
